import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import EvaluationPage from "@/pages/EvaluationPage";
import ResultsPage from "@/pages/ResultsPage";

function App() {
  return (
    <div className="App min-h-screen bg-obsidian">
      {/* Noise texture overlay */}
      <div className="noise-overlay" />
      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/evaluacion" element={<EvaluationPage />} />
          <Route path="/resultados" element={<ResultsPage />} />
        </Routes>
      </BrowserRouter>
      
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
